@if(validationContext){
<div [formGroup]="form" class="forenklad-riskbedomning-form-container">
    <div class="row">
        <div class="col">
            <rask-header size="3">Riskbedömning av leveransvirke/leveransgrot: Övrig avverkning</rask-header>
            <p class="instructions">Ta stöd av de parametrar du själv brukar bedöma vid en
                naturvärdesbedömning, i
                dialog med
                leverantören, för att
                kunna svara på nedan lista.</p>
        </div>
    </div>

    <rask-card [renderRaskheader]="false">
        <div class="row align-items-center">
            <div class="col-9">
                Leverantören förstår att Sveaskog inte köper träråvara från nyckelbiotoper eller från skogar med höga
                bevarandevärden (bl. a. hänsynskrävande biotoper)
                där brukandet av skogen hotar dessa värden. Träråvara från sådana områden får inte ingå i leveransen.
            </div>
            <div class="col-3">
                <rask-radiobutton-group
                    formControlName="leverantorAccepterarPolicy"
                    class="forenklad-riskbedomning-radiogroup"
                    [verticalLayout]="false"
                    [buttons]="[{ key: true, value: 'Ja' }, { key: false, value: 'Nej' }]">
                </rask-radiobutton-group>
            </div>
        </div>
    </rask-card>
    <rask-card [renderRaskheader]="false">
        <div class="row align-items-center">
            <div class="col-9">
                Leverantören förstår gällande lagar och hur dessa påverkar avverkningsåtgärden. Kontrollera t. ex.
                registrerade artfynd inom avverkningsområdet.
            </div>
            <div class="col-3">
                <rask-radiobutton-group
                    formControlName="leverantorKontrolleratLaguppfyllnad"
                    class="forenklad-riskbedomning-radiogroup"
                    [verticalLayout]="false"
                    [buttons]="[{ key: true, value: 'Ja' }, { key: false, value: 'Nej' }]">
                </rask-radiobutton-group>
            </div>
        </div>
    </rask-card>

    <rask-card [renderRaskheader]="false">
        <div class="row align-items-center">
            <div class="col-9">
                Gå igenom de avverkningsområden som är aktuella. Kontrollera mot skogsbruksplan och/eller kartverktyg
                som Skogliga grunddata och Skogens pärlor.
                Kan Leverantören redogöra för var och vilken träråvara som planeras att avverkas, eller har blivit
                avverkad?
            </div>
            <div class="col-3">
                <rask-radiobutton-group
                    formControlName="leverantorKontrolleratAvverkning"
                    class="forenklad-riskbedomning-radiogroup"
                    [verticalLayout]="false"
                    [buttons]="[{ key: true, value: 'Ja' }, { key: false, value: 'Nej' }]">
                </rask-radiobutton-group>
            </div>
        </div>
    </rask-card>
    <rask-card [renderRaskheader]="false">
        <div class="row align-items-center">
            <div class="col-9">
                Indikerar den dialog du har med Leverantören att ett fältbesök i avverkad/planerad avverkning behövs för
                att säkerställa Sveaskogs ursprungskrav på inköp
                av träråvara?
            </div>
            <div class="col-3">
                <rask-radiobutton-group
                    formControlName="faltbesokKravs"
                    class="forenklad-riskbedomning-radiogroup"
                    [verticalLayout]="false"
                    [buttons]="[{ key: true, value: 'Ja' }, { key: false, value: 'Nej' }]">
                </rask-radiobutton-group>
            </div>
        </div>
        @if(naturvardesbedomning()?.faltbesokKravs){
        <div class="row datepicker-container">
            <div class="col">
                <rask-datepicker
                    [rule]="validationContext.current.faltbesokKravs"
                    label="Fältbesök genomfört"
                    formControlName="faltbesokDatum">
                </rask-datepicker>

            </div>
        </div>
        }
    </rask-card>
    <rask-card [renderRaskheader]="false">
        <div class="row align-items-center">
            <div class="col-9">
                Resulterar din riskbedömning utifrån dels denna checklista och dels övrig dialog med Leverantören att
                den
                träråvara som affären ska avtala om uppfyller
                Sveaskogs ursprungskrav på inköp av träråvara?
            </div>
            <div class="col-3">
                <rask-radiobutton-group
                    formControlName="naturvardesbedomningUtford"
                    class="forenklad-riskbedomning-radiogroup"
                    [verticalLayout]="false"
                    [raskDisabledControl]="!canComplete()"
                    (ngModelChange)="$event ? setUtfordAv() : resetUtfordAv()"
                    [buttons]="[{ key: true, value: 'Ja' }, { key: false, value: 'Nej' }]">
                </rask-radiobutton-group>
            </div>
        </div>
    </rask-card>
</div>

}